module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "p36"
    }
  }), _vm._v("2. Reading and Sociability")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Bo & me dined at G.P. [grandfather’s house] we took a walk to Kilburn after dinner Mrs Cary drank at G.P. Bo & me Read to G.P.")]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_vm._v("—Diary of William Burgess, 19 March 1790")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Home or Abroad?")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("In 1785 the thirty-five-year-old Elizabeth Brain proudly put the final stitches into the embroidered sampler she had been working on for several weeks ("), _c('a', {
    attrs: {
      "href": "#/#fig8"
    }
  }, [_vm._v("fig. 8")]), _vm._v("). A stretch of woolen canvas, the size of an A4 piece of paper, it was a bold and confidently executed piece, embellished in fine detail with coloured silks. Its subject, like many of its kind, was the life of the home. It depicts a four-square house finely set in a landscaped garden, a sinuous drive twisting through carefully placed fruit trees and deer. A curved bench beside a lake offers a place for contemplation of the ordered idyll. Right at the heart of the composition, Elizabeth Brain has embroidered some text, which reads: “Conversation speak with ease, / Shun Barbarous words / as Rocks in seas.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("This sampler is an object that says much about domesticity in the eigh-teenth century. Shunning religious themes in favour of the robustly secular, Elizabeth Brain chose to embroider a piece that celebrated both the material joys of a home and the social values associated with this idyll—easy conversation, a world free of jarring discord. Her act of needlework was also a testament to her own domestic virtue, a vision of a home as a place of respite, yet one in which hands were never idle. With its twinnings of home and sociability, leisure and virtuous productivity, her work embodies many of the fundamental concepts that inform shared reading in the eighteenth-century home.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("By the end of the eighteenth century there were numerous newly available places in which to spend leisure time and money in company—pleasure "), _c('a', {
    attrs: {
      "id": "p37"
    }
  }), _vm._v("gardens, coffeehouses, museums, and concerts were a novelty, and the cause of much comment and excitement."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-1",
      "id": "nr2-1"
    }
  }, [_vm._v("1")])]), _vm._v(" It is undoubtedly true that many people took full advantage of these innovations in external leisure activity. But diaries and inventories show us that the home remained an essential place of recreation for women—and men—of property."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-2",
      "id": "nr2-2"
    }
  }, [_vm._v("2")])]), _vm._v(" Our forebears supped, they dined, they played cards, read, gossiped, argued, and performed music together in their homes throughout the eighteenth century. The choice of home over away would have been in part determined by economics and geography. For those living in the countryside, socializing in the home would have been the norm. Nicholas Blundell, a Catholic landowner living in Little Crosby, an estate just south of Liverpool, notes many occasions for spontaneous and extensive hospitality of family and neighbours:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Williams",
      "src": "images/page_37.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig8"
    }
  }, [_vm._v("Fig. 8. Sampler by Elizabeth Brain, 1785, woolen canvas embroidered with silks (Victoria and Albert Museum, T.750-1974; © Victoria and Albert Museum, London)")]), _vm._v(" "), _c('p', {
    staticClass: "ex_alone"
  }, [_vm._v("Whilst I was out I was sent for home, being my brother Langdale was come to lodg here … Lord Molineaux sent a Servant to let us "), _c('a', {
    attrs: {
      "id": "p38"
    }
  }), _vm._v("know he intended to dine here on Thursday … Coz. Scarisbrick sent to let me know his famoly and Croston famoly design to lodge here on Monday Next … William Ainsworth came here betymes in ye Morning. He brought a Present of Fish. He went a-Coursing with me. He lodged here."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-3",
      "id": "nr2-3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Blundell’s roll call of his guests is interesting for what it tells us about the range of people he hosted—in this case, his guests run from the local aristocracy (Molineaux), to his tenant farmer (Ainsworth), to his extended family. It is also clear that this hospitality was often impromptu, and could stretch out for a considerable period of time. It would have demanded a capacious larder and the ability to provide meals for large groups at short notice—Blundell’s “Disbursement Book” shows that food and drinks were laid on in quantities that reflect continual and large-scale entertaining."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-4",
      "id": "nr2-4"
    }
  }, [_vm._v("4")])]), _vm._v(" One of the interesting features of Blundell’s diary is that he records his life in relation to social exchanges. Each volume of the diary is prefaced by an index that includes the following categories:")]), _vm._v(" "), _c('p', {
    staticClass: "nl-t"
  }, [_c('span', {
    staticClass: "rnlblock"
  }, [_vm._v("I.")]), _vm._v("We lodged abroad or came home. Servants or others went hence or came to live here.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "rnlblock"
  }, [_vm._v("II.")]), _vm._v("We dined abroad or were abroad at Noone.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "rnlblock"
  }, [_vm._v("III.")]), _vm._v("We made Visets after Diner")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "rnlblock"
  }, [_vm._v("IV.")]), _vm._v("At Diversions at Home or Abroad …")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "rnlblock"
  }, [_vm._v("IX.")]), _vm._v("Persons dined or suped here or came after Diner.")]), _vm._v(" "), _c('p', {
    staticClass: "nl-b"
  }, [_c('span', {
    staticClass: "rnlblock"
  }, [_vm._v("XV.")]), _vm._v("Relating to Licker. Commicall Passages or pleasant … dis-cours."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-5",
      "id": "nr2-5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("That this is the primary way in which he categorises his time and marks out the year is significant. Blundell’s access to public entertainments would have been limited by the fact that he lived in a small rural village in Lancashire. Domestic entertainment wasn’t just the fate of those living outside London, or those with families, however. Even unmarried bachelors spent evenings at home entertaining their friends rather than out at the inn or coffeehouse. Dudley Ryder spends a large part of his time entertaining his friends in his rooms, or visiting them. The same is true for many seemingly clubbable men of the eighteenth century who, like James Boswell, embraced home entertainment with enthusiasm—and not just because it was cheaper. The inventories of middle-class domestic houses show that the prime location for the entertainment of others—the parlour—frequently included a card table, a "), _c('a', {
    attrs: {
      "id": "p39"
    }
  }), _vm._v("harpsichord, game boards, and tea tables."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-6",
      "id": "nr2-6"
    }
  }, [_vm._v("6")])]), _vm._v(" They also seem often to have contained objects to interest others, and diarists of the period mention showing collections of fossils, prints, or drawings to their friends. The Norfolk parson James Woodforde describes being shown (at some length) the coin collection of a clerical friend; London lawyer Sylas Neville collects shells, fossils, and semiprecious stones and entertains in his “best parlor”;"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-7",
      "id": "nr2-7"
    }
  }, [_vm._v("7")])]), _vm._v(" Henry Prescott, a clerical official from Chester, spends evenings with local male friends discussing ideas, books, and antiquities over a “domestic pint.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-8",
      "id": "nr2-8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("The Advantages of Home Entertainment")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Staying at home was often more practical and cheaper than going out. But it also had moral benefits, particularly for women. Was it really wholesome to spend one’s time amongst relative strangers? James Fordyce counsels his female readers to be cautious of the giddy world of public sociability: “Are these the scenes of true enjoyment? What, where the heart cannot be unfolded; where the understanding has little or no play; where all is reserve, ceremony, show?”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-9",
      "id": "nr2-9"
    }
  }, [_vm._v("9")])]), _vm._v(" Public gatherings and entertainments were all surface, he argued, and because of that they could provide no lasting enjoyment. Those who had to turn to such follies to amuse themselves were to be pitied, because they were unable to find enjoyment closer to home: in themselves, in reading, in rational conversation, amongst their family, or in “real friendship.” Fordyce’s emphasis on the home reminds us that the house was not necessarily a place of retreat from social exchange. As he saw it, it was within the home that one found the lasting and beneficial pleasures of friendship and conversation. We find similar arguments made by the anonymous editor of a collection of popular poetry published in 1750, entitled "), _c('i', [_vm._v("A New Tea-Table Miscellany: or, Bagatelles for the Amusement of the Fair Sex.")]), _vm._v(" Like Fordyce’s sermons, this collection was aimed at female readers, and the pleasures of conversation at home, around the tea table, are gendered. Conversation, we are told,")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("is no where to be found so perfect, and free from the views of interest, the stings of rancor, or the pangs of revenge, as at the TEA–TABLE; for if the merchant transacts business with his brother-merchant, the sweets of the conversation are lost, and as it were swallow’d up in the diffidence they have of each other, the "), _c('a', {
    attrs: {
      "id": "p40"
    }
  }), _vm._v("dread they have of being over-reach’d, and the gloomy imaginations of losing some of that fortune, the encrease of which is their daily care. Hence arises the unmanly habit of dissimulation, of keeping ourselves upon the reserve, and lying in wait to take advantage of the slips and weaknesses of each other.")]), _vm._v(" "), _c('p', {
    staticClass: "exb"
  }, [_vm._v("But at the social and grief-removing tea table, all selfish views are lost, all restraint is laid aside, all ceremony discarded, all the company is entitled to the same freedom, and all glad to bless and be bless’d, in the mutual reception and diffusion of happiness and pleasure."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-10",
      "id": "nr2-10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("This author, like Fordyce, emphasises the potential for deception and dissimulation within more public arenas. He also stresses the improving potential of mixed company within the home—the company around the table consists, he says, of “parents and their children, brothers and sisters, friends, relations and strangers.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-11",
      "id": "nr2-11"
    }
  }, [_vm._v("11")])]), _vm._v(" This is in sharp contrast to the competitive all-male environment he associates with socializing outside the home—which, perversely, can foster the “unmanly” habit of dissimulation."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-12",
      "id": "nr2-12"
    }
  }, [_vm._v("12")])]), _vm._v(" Sociability in mixed company was increasingly perceived to be more polite than all-male gatherings."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-13",
      "id": "nr2-13"
    }
  }, [_vm._v("13")])]), _vm._v(" The paradigm of the mixed group was an emblem of virtue and prosperity, as the many conversation-piece portraits of the period amply illustrate."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-14",
      "id": "nr2-14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Within the world of domestic hospitality there were very different ways of seeing others at home. In London, a typical pattern might involve several short visits in one day. But in the country, with longer distances, visiting was more likely to take the form of a prolonged period staying with a host."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-15",
      "id": "nr2-15"
    }
  }, [_vm._v("15")])]), _vm._v(" In fact, we can see contemporaries disputing the merits of these different kinds of social occasions. Was a house party more beneficial than a visit? How long was long enough in the company of others? Surviving diaries of the period reveal a bewildering number of visits made and received during the course of each day."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-16",
      "id": "nr2-16"
    }
  }, [_vm._v("16")])]), _vm._v(" A sample entry from the diary of Elizabeth Tyrrell, a middle-aged mother from a professional merchant family living just outside London, lists many instances of impromptu hospitality, in which friends and family would meet, part, regroup later in the day, go out again, and receive different sets of visitors. One might be tempted to think that such visiting was curtailed by the darkness of nights without electricity. But Tyrrell, like other eighteenth-century diarists, routinely stays up late: in August 1808 she spends the day with a group of people at Hampton Court, not arriving home in Kew until "), _c('a', {
    attrs: {
      "id": "p41"
    }
  }), _vm._v("nine o’clock in the evening. After that they have tea and coffee, and after that one of the guests goes for his violin and is accompanied on the flute: “they played Country dances, and four Couples stood up. I gave them some warm Wine & Water to drink, and they danced till One o’clock, when we separated.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-17",
      "id": "nr2-17"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Others show a similar ability to burn the midnight oil—or candle—regardless of the season. Mary Curzon writes to the unmarried Northamptonshire heiress Mary Heber of her stay at Hagley in Worcestershire in November 1776: “We are quite rakes here, for we seldom come home before twelve.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-18",
      "id": "nr2-18"
    }
  }, [_vm._v("18")])]), _vm._v(" Elizabeth Raper, daughter of an East India merchant living in Eltham, just outside London, writes of going into town for the day, and returning home: “Dark by that we got to Eltham … Arrived safe at Foot’s Cray between 7 and 8. Mr. Hotham was determined on going several times, but somehow he staid all night. Read Hogarth’s Analogies, supped, sung, and came up to bed before one.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-19",
      "id": "nr2-19"
    }
  }, [_vm._v("19")])]), _vm._v(" The shopkeeper Thomas Turner describes one particularly memorable night out (and in) in February 1757 that he spends with his neighbours and the local vicar:")]), _vm._v(" "), _c('p', {
    staticClass: "ex_alone"
  }, [_vm._v("About 10.20 we went to supper on 4 boiled chicken, 4 boiled ducks, some minced veal, sausages, cold roast goose, cold chicken pasty, cold ham … After supper our behaviour was far from that of serious, harmless, mirth for it was downright obstreperious mirth mixed with a great deal of folly and stupidity. Our diversion was dancing (or jumping about) without a violin or any music, singing of foolish healths, and drinking all the time as fast as it could be well poured down … [about three thirty] I came home … This morn about 6 o’ clock, just as my wife was gladly got to bed and had laid herself down to rest, we was awakened by Mrs. Porter, who pretended she wanted some cream of tartar. But as soon as my wife got out of bed, she vowed she should come down … Then the next thing in course must be to have me downstairs, which I being apprized of, I fastened my door … As soon as ever it was open, they poured into my room, and as modesty forbid me to get out of my bed in the presence of women, they drew me out of bed (as the common phrase is) tipsy turvy … and instead of my clothes, they gave me time to put on my wife’s petticoat. In this manner they made me dance with them without shoes and stockings until they had emptied their bottle of wine and also a bottle of my beer."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-20",
      "id": "nr2-20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p42"
    }
  }), _vm._v("Hospitality took different forms, and Turner’s twenty-four-hour drinking binge was the exception rather than the rule. Wild evenings like this one, or large house parties, were different from a single friend coming to drink tea or a couple staying to play cards for an evening. Not everyone threw themselves into the constant round of visiting with sustained enthusiasm. The diarist John Evelyn had complained about “the tediousness of "), _c('i', [_vm._v("Visits,")]), _vm._v(" which they make "), _c('i', [_vm._v("here")]), _vm._v(" so long, that it is a very tyranny to sit to little purpose.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-21",
      "id": "nr2-21"
    }
  }, [_vm._v("21")])]), _vm._v(" A century later, they were still tiresome. A letter of July 1785 from the gossipy young Elizabeth Iremonger to her friend Mary Heber identifies rounds of visits as the great evil of domestic sociability."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-22",
      "id": "nr2-22"
    }
  }, [_vm._v("22")])]), _vm._v(" Visits were different from invitations in that they were unsolicited, numerous, and often short. Like many other young women of her age, Elizabeth Watkins, living in Gloucester, recorded her daily activities in a pocket book, a formatted diary that contained columns for account and note keeping. Elizabeth used hers to record what she felt about her visitors, as well as when they came. She notes on 1 March 1771: “Mrs. Clifford call’d in. I am very indifferent”; on 7 April, “Mrs. Lee drank tea here—a stupid kind of evening”; on 6 May, “Miss Elderton call’d in the morn. I do not like her at all.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-23",
      "id": "nr2-23"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Social visits might have been tiresome, but they were a compulsory feature of polite town life. Not every day was perceived as suitable for seeing others. The clergyman James Hervey worried about the way in which the Sabbath was becoming the default visiting day. It was fine, he thought, to spend time in the company of others on Sundays if they were religious: “But, alas! where do we find such Company? When do we hear such Conversation? The general Conversation is all Impertinence. Not so much as seasoned with a Spice of Religion.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-24",
      "id": "nr2-24"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("For those of a more worldly outlook, friendships and alliances could be cemented through the right kinds of visiting, and the trading of visiting cards, small rectangular slips of paper or pasteboard on which the owner’s name was written, engraved, or letterpress printed, provided a paper trail of who had been where. Once deposited at a genteel address, cards were kept on semi-display within handmade visiting card holders."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-25",
      "id": "nr2-25"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('i', [_vm._v("The Ladies’ Complete Visiting Guide")]), _vm._v(" (1800) presented the visiting card as the chief measure of sociability, and visiting as a “serious occupation.” The author claimed that he had in his manual “hereby reduced to a system the first acknowledged felicity of polished society—"), _c('i', [_vm._v("friendly, learned,")]), _vm._v(" and "), _c('i', [_vm._v("fashionable intercourse.")]), _vm._v("”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-26",
      "id": "nr2-26"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_c('a', {
    attrs: {
      "id": "p43"
    }
  }), _vm._v("Virtue and Display")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Within the wholesome space of the home, some entertainments were seen as more suitable than others. James Fordyce devotes a large part of his discussion of home leisure time to the insidious evils of card playing—a staple of many an evening in, but in his eyes a dangerous transgression of “the laws of humanity and friendship.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-27",
      "id": "nr2-27"
    }
  }, [_vm._v("27")])]), _vm._v(" The “lust of gaming” should, he argued, be more properly replaced by gentler arts, and in particular needlework."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-28",
      "id": "nr2-28"
    }
  }, [_vm._v("28")])]), _vm._v(" The great virtue of needlework was, he observed, that it enabled one to engage in other improving arts at the same time. Not all needlework was equal—“slighter and freer patterns” were recommended over intricate “fancywork,” because they were less likely to strain the eyes, took less time, and would be more useful."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-29",
      "id": "nr2-29"
    }
  }, [_vm._v("29")])]), _vm._v(" Fordyce cited the example of a woman of nobility and virtue:")]), _vm._v(" "), _c('p', {
    staticClass: "ex_alone"
  }, [_vm._v("who never sat idle in company. … Being a perfect mistress of her needle, and having an excellent taste in that, as in many other things, her manner, whether at home, or abroad … was to be constantly engaged in working something useful, or beautiful; at the same time that she assisted in supporting the conversation, with an attention and capacity which I have never seen exceeded. For the sake of variety and improvement, when in her own house, some one of the company would often read aloud, while she and her female visitants were thus employed."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-30",
      "id": "nr2-30"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("The paragon described here is exemplary because she is never idle in her leisure time, and she uses it to combine several of Fordyce’s favoured activities: she makes beautiful or useful things, she engages in rational and intelligent conversation—and, to top it all, she is enlarging her mind and those of the women with her by listening to a book read aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Reading aloud was doubly beneficial because it kept one from idleness, and provided an improving and entertaining soundtrack to other domestic activities. The bluestocking letter writer and artist Mary Delany recommends Boswell’s "), _c('i', [_vm._v("Tour of the Hebrides")]), _vm._v(" as an excellent book to listen to while doing knotting work; Eleanor Butler, one of the “Ladies of Llangollen,” living in artistic retirement in a village in North Wales, describes reading to her companion Sarah Ponsonby, who was meanwhile occupied in drawing, making a map, doing cross-stitch, or decorating her journal."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-31",
      "id": "nr2-31"
    }
  }, [_vm._v("31")])]), _vm._v(" Nearly all the reading recorded in Elizabeth Tyrrell’s London diary takes the form of one woman reading aloud, while the rest of the group work. And it was not only "), _c('a', {
    attrs: {
      "id": "p44"
    }
  }), _vm._v("women who read to stave off idleness, or who combined reading with work. Robert Sharp, a Yorkshire schoolmaster and shopkeeper, declared that “there is not a more uncomfortable thing (at least to me) to see a person lolling about in a Chair, spending his time with nothing, never looking at a Book, for my part sooner than be debarred from reading, I would suffer the odious punishment of the tread Mill.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-32",
      "id": "nr2-32"
    }
  }, [_vm._v("32")])]), _vm._v(" Nicholas Blundell was indefatigable in his home and garden improvements, planting, mending, cleaning—his diary records a life busy with tasks around his estate. He too records the utility of reading as a soundtrack to work: “After dinner I tryed to set some Rayzors and Mr. Aldred red to me the Prognostications of Esqr Bigerstaff.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-33",
      "id": "nr2-33"
    }
  }, [_vm._v("33")])]), _vm._v(" For those further down the social scale, the relationship between reading and work was different. The self-taught publisher James Lackington describes his zeal for reading while he was an apprentice shoemaker. He recalls that he and his fellow apprentices were so eager to read as much as they could that they allowed themselves only three hours’ sleep a night, and that “one of us sat up to work until the time appointed for the others to rise, and when all were up, my friend John, and your humble servant, took it by turns to read aloud to the rest, while they were at their work.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-34",
      "id": "nr2-34"
    }
  }, [_vm._v("34")])]), _vm._v(" Hugh Miller, from an artisan family in the small Scottish coastal burgh of Cromarty, describes how his uncle James, a harness maker, managed to read while he worked:")]), _vm._v(" "), _c('p', {
    staticClass: "ex_alone"
  }, [_vm._v("He often found some one to read beside him during the day; and in the winter evenings the portable bench used to be brought from his shop at the other end of the dwelling, into the family sitting-room, and placed beside the circle round the hearth, where his brother Alexander, my younger uncle, whose occupation left his evenings free, would read aloud from some interesting volume for the general benefit—placing himself always at the opposite side of the bench, so as to share in the light of the worker. Occasionally the family circle would be widened by the accession of two to three intelligent neighbours, who would drop in to listen; and then the book, after a space, would be laid aside, in order that its contents might be discussed in conversation."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-35",
      "id": "nr2-35"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The opportunities for reading at work depended on the workplace. In artisan workshops where discipline could be relaxed, where there were opportunities for contact with older employees and masters who were better able to afford reading material, a unit was provided within which readers could group together to buy books and newspapers. Those who worked in "), _c('a', {
    attrs: {
      "id": "p45"
    }
  }), _vm._v("groups had the advantages of conversation."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-36",
      "id": "nr2-36"
    }
  }, [_vm._v("36")])]), _vm._v(" Keen readers took their chances where they found them. The servant John Jones describes how he used to hurry in laying the dinner table, so that he might gain a few minutes to explore the contents of the bookshelves in the dining room."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-37",
      "id": "nr2-37"
    }
  }, [_vm._v("37")])]), _vm._v(" An anonymous stonemason, employed as a roundsman (a travelling labourer), taught his horse the route of his journeys, and from then on, read while he travelled."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-38",
      "id": "nr2-38"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("These accounts show us very different functions of reading in relation to work. For leisured men and women of the gentry and middle classes, to do craft and handiwork while another person read aloud was companionable, and virtuous because it meant that neither was idle in their leisure time. But for the working man or woman, reading aloud at work was a way of improving oneself through learning and alleviating the tedium of manual labour.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("These two worlds—reading as soundtrack for recreation and reading while undertaking paid work—could collide within the eighteenth-century home."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-39",
      "id": "nr2-39"
    }
  }, [_vm._v("39")])]), _vm._v(" Servants were often part of the shared reading experience. Gertrude Savile spent several happy days walking in the fields with her maid, Peell, and a book. The maidservant in Thomas Turner’s household often listened to her employer’s reading, and Hester Piozzi’s maid listened while she read the "), _c('i', [_vm._v("Spectator")]), _vm._v(" to her daughters."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-40",
      "id": "nr2-40"
    }
  }, [_vm._v("40")])]), _vm._v(" An often cited scene of reading aloud was during the lengthy process of hairdressing and the curling and powdering of wigs. This habit was so prevalent that an article entitled “Hints on Reading” in "), _c('i', [_vm._v("The Lady’s Magazine")]), _vm._v(" of 1789 claimed that “hair-dressing has been very serviceable to reading—Look at the popular books of a circulating library, and you will find the binding cracked by quantities of powder and pomatum between the leaves.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-41",
      "id": "nr2-41"
    }
  }, [_vm._v("41")])]), _vm._v(" The editor went on to recommend, tongue firmly in cheek, that “for the hour of hair-dressing, which is sometimes an hour of torment, I would reserve newspapers and political pamphlets—and so get rid of all my plagues at once.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-42",
      "id": "nr2-42"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Being Seen")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Fordyce describes his female paragon who sews, converses, and listens as a spectacle: it is by witnessing her conduct that he infers her moral compass. Despite the didactic emphasis on the unaffected freedom of the home, domestic recreation was closely linked to display. It was important to be seen to be doing and saying the right things when visited or visiting.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p46"
    }
  }), _vm._v("The history of home decoration reveals that the mid–eighteenth century was when householders began to take serious interest in the spaces in which they received others. Wallpapers, carpets, and sets of china were bought in large quantities by women and men eager to impress their visiting friends."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-43",
      "id": "nr2-43"
    }
  }, [_vm._v("43")])]), _vm._v(" As the middling sort of Britons became a nation of shoppers, so their homes became crowded with fashionable new things to show off to their visitors. Teaware, silver plate, sugar tongs, candle snuffers, pepper casters, japanned trays, and numerous other items were advertised, bought, and shown off on a huge scale."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-44",
      "id": "nr2-44"
    }
  }, [_vm._v("44")])]), _vm._v(" The author of "), _c('i', [_vm._v("The Lady’s Companion")]), _vm._v(" warned that formal visits were often nothing more than custom-sanctioned nosiness: “many go to see those, for whom they are perfectly indifferent whether they find them alive or dead, well or sick,” and claimed that such visits “are but insidious Instructions of a Spy rather than the Good Office of a Neighbour.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-45",
      "id": "nr2-45"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Given that part of the game of visiting was to examine how others lived, the same principles of aspirational display applied to the activities of the people within these rooms as to their contents. James Gillray’s satirical portrait entitled "), _c('i', [_vm._v("Farmer Giles and his wife shewing off their daughter Betty on her return from school")]), _vm._v(" parodies the aspirations of middling-sort domestic culture, the neighbours having been summoned round to hear the daughter’s piano rendition of a popular folk tune while her parents beam on, heedless to the fact that no one (including the dog) is listening ("), _c('a', {
    attrs: {
      "href": "#/#fig9"
    }
  }, [_vm._v("fig. 9")]), _vm._v("). A conduct book from the mid–eighteenth century entitled "), _c('i', [_vm._v("The Lady’s Preceptor")]), _vm._v(" offers readers sound advice on how to prepare to speak during a visit. Conversation during a visit should be approached with the same care and preparation that one would apply to matters of dress or hair. Cautioning his readers not to fall into the trap of “caressing the first Dog that comes to their Relief, … without which they would not have known how to have behaved,” he advises them on how to sparkle:")]), _vm._v(" "), _c('p', {
    staticClass: "ex_alone"
  }, [_vm._v("If the Occasion of the Visit does not afford you a Subject for Conversation, take care not to be so unprovided with one, as to be obliged to the Weather or the Hour of the Day for your Discourse. It is not at all amiss to consider, before-hand, what Topicks are suitable to the Company you are going to see, and to make yourself in some measure Mistress of them."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-46",
      "id": "nr2-46"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Conversation was part of the performance involved in social exchanges, and even within the relatively informal contexts of domestic visiting, it was "), _c('a', {
    attrs: {
      "id": "p47"
    }
  }), _vm._v("important to do it right. In theory, conversation brought out the best in people, since “in company we frequently say a thousand smart and ingenious things which never would have come into our head while alone.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-47",
      "id": "nr2-47"
    }
  }, [_vm._v("47")])]), _vm._v(" Yet it demanded practice, as the compiler of the Ernst family commonplace book observed: “Men of the World can only shew their wit by their Conversation. It is not therefore astonishing they should aim at doing that which makes them shine.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-48",
      "id": "nr2-48"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Williams",
      "src": "images/page_47.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig9"
    }
  }, [_vm._v("Fig. 9. James Gillray, "), _c('i', [_vm._v("Farmer Giles and his wife shewing off their daughter Betty on her return from school,")]), _vm._v(" London, 1809, etching (Library of Congress, LC-USZC2-3808)")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("No one could have been more aware of the need to learn how to acquire conversation pieces and verbal wit than poor Dudley Ryder. Ryder’s diary spans only a couple of years in his youth, but it offers an extraordinarily candid account of one man’s struggle to be sociable."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-49",
      "id": "nr2-49"
    }
  }, [_vm._v("49")])]), _vm._v(" Most of the time what Ryder is really worried about is what to say and how to say it. He watches other men, who seem to talk freely and with charm, but observes of himself: “I find I am mighty apt to look silly and a little uneasy when I am in the company of ladies.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-50",
      "id": "nr2-50"
    }
  }, [_vm._v("50")])]), _vm._v(" Ryder thinks that he can learn to speak well in company by reading books. The books he favours are not didactic works on eloquence or manners, but books that seem to him to embody stylistic traits that he can emulate. So he notes that no book is more fit “to learn one the polite way of writing and conversing than Horace, and one cannot be too familiar with "), _c('a', {
    attrs: {
      "id": "p48"
    }
  }), _vm._v("him.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-51",
      "id": "nr2-51"
    }
  }, [_vm._v("51")])]), _vm._v(" He admires Boileau for his informality, and declares that he will read frequently "), _c('i', [_vm._v("The Tatler,")]), _vm._v(" “to improve my style and accustom myself to his way of thinking and telling a story and manner of observing upon the world and mankind.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-52",
      "id": "nr2-52"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("It is worth pausing here to consider the way in which the aesthetic qualities valued in the literature of the period—ease, conversational style, wit—were read as a code for living, however ill-suited they seemed to be to one’s own character. Ryder’s anxious and self-conscious attitude towards reading may not be typical of all men of the early eighteenth century, but it gives us an insight into the way he translated what he found in books into his own personal social predicaments. He is rather scornful of his cousin who, he says, has spent too much time doing the wrong kind of reading: she “has not the talent of conversation, says very little, reads much and delights mightily in books of gallantry, romances and tragedies but her great defect is her ignorance of mankind.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-53",
      "id": "nr2-53"
    }
  }, [_vm._v("53")])]), _vm._v(" Some books equip you for conversation, and some, apparently, hinder it.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("However artificial it may seem today, Ryder’s candid narrative of his own struggle to converse with ease, and the role that reading played within this, is important for understanding how people "), _c('i', [_vm._v("used")]), _vm._v(" books in the eighteenth century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-54",
      "id": "nr2-54"
    }
  }, [_vm._v("54")])]), _vm._v(" When James Fordyce came to write his sermon “On Female Virtue with Intellectual Accomplishments,” reading and using one’s reading were presented as a fundamental part of that accomplishment. He declared that reading could entertain and edify, enable one to enjoy solitude, but also “qualify you to shine in conversation.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-55",
      "id": "nr2-55"
    }
  }, [_vm._v("55")])]), _vm._v(" Later on we will see how this influenced the forms of books that were published, specifically collections of writing deliberately packaged and edited to provide material for social occasions.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In the context of domestic sociability, what you read and what you said were often seen as a show to present to the world, rather than as a fundamental aspect of intellectual or personal identity. The writer and journalist Harriet Martineau looked back scornfully at this practice, within which the female reader was")]), _vm._v(" "), _c('p', {
    staticClass: "ex_alone"
  }, [_vm._v("expected to sit down in the parlour with her sewing, listen to a book read aloud, and hold herself ready for [female] callers. When the callers came, conversation often turned naturally on the book just laid down, which must therefore be very carefully chosen lest the shocked visitor should carry to the house where she paid her "), _c('a', {
    attrs: {
      "id": "p49"
    }
  }), _vm._v("next call an account of the deplorable laxity shown by the family she had left."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-56",
      "id": "nr2-56"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("The spectacle of the reading woman and the conversation that her book furnished her with were typically ways in which visitors were to evaluate a person and a home. For Martineau, this window-dressing is explicitly gendered.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Books as indicators of the moral propriety of their female owners can be seen in prints and novels throughout the eighteenth century, which often use the titles of books visible in the home as a sign of moral rectitude—or otherwise."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-57",
      "id": "nr2-57"
    }
  }, [_vm._v("57")])]), _vm._v(" In Richard Sheridan’s play "), _c('i', [_vm._v("The Rivals,")]), _vm._v(" Lydia Languish, a young woman with an insatiable appetite for romantic fiction, has to cover up in haste the true nature of her reading material when her family are about to enter her room: “Here, my dear Lucy, hide these books.—Quick, quick.—Fling "), _c('i', [_vm._v("Peregrine Pickle")]), _vm._v(" under the toilet—throw "), _c('i', [_vm._v("Roderick Random")]), _vm._v(" into the closet—put "), _c('i', [_vm._v("the Innocent Adulter")]), _vm._v("y into "), _c('i', [_vm._v("The Whole Duty of Man")]), _vm._v("—thrust "), _c('i', [_vm._v("Lord Aimworth")]), _vm._v(" under the sopha … leave "), _c('i', [_vm._v("Fordyce’s Sermons")]), _vm._v(" upon the table.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-58",
      "id": "nr2-58"
    }
  }, [_vm._v("58")])]), _vm._v(" Novels are quickly shoved out of sight, and what remains on show is what is respectable—the conduct book "), _c('i', [_vm._v("The Whole Duty of Man")]), _vm._v(" and Fordyce’s sermons.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Similar principles applied to male reading. One anonymous satire of the period takes as its subject the college room of a young man. The poem is a response to Jonathan Swift’s poem “The Lady’s Dressing Room,” which had famously described a male lover’s horror at the seedy contents of his beloved’s dressing room, cluttered with cosmetics and bodily sweat and grime. In the response poem, “A Description of a College Room,” we are given a peep into the chaotic moral universe of a young man about town:")]), _vm._v(" "), _c('p', {
    staticClass: "poem-t"
  }, [_vm._v("Where various books confus’dly lie,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("Scotch songs,")]), _vm._v(" with deep "), _c('i', [_vm._v("philosophy,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("A "), _c('i', [_vm._v("Prior")]), _vm._v(" here, and "), _c('i', [_vm._v("Euclid")]), _vm._v(" there,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("A "), _c('i', [_vm._v("Rochester")]), _vm._v(" and "), _c('i', [_vm._v("book of prayer;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Here "), _c('i', [_vm._v("Tillotson")]), _vm._v(" with "), _c('i', [_vm._v("French romances,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem-b"
  }, [_vm._v("And pious "), _c('i', [_vm._v("South")]), _vm._v(" with "), _c('i', [_vm._v("country dances.")]), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-59",
      "id": "nr2-59"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Again, we read the moral calibre of the man from the books on his table: songs and dances muddled up with Tillotson’s sermons and Euclid’s classical geometry, and the Earl of Rochester’s libertine verse alongside a book of prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_c('a', {
    attrs: {
      "id": "p50"
    }
  }), _vm._v("Spaces for Reading")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Eighteenth-century literature and visual art often use books as a vocabulary of moral rectitude. The choice of books on display within a house—whether being read or in sight on table or shelves—was significant. In larger houses, it had an added significance because of the eighteenth-century shift towards the use of the library as a general living space."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-60",
      "id": "nr2-60"
    }
  }, [_vm._v("60")])]), _vm._v(" Descriptions of domestic libraries of the sixteenth and seventeenth centuries typically reveal places of retreat and solitude, which were primarily aristocratic. Over the course of this period, the contents of the private library evolved—by the end of the seventeenth century, there would have been fewer continental books in learned languages, and more works printed in England, in English."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-61",
      "id": "nr2-61"
    }
  }, [_vm._v("61")])]), _vm._v(" Some of those library owners would have acquired their books for their intellectual content, and others, as status symbols—the two are not mutually exclusive."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-62",
      "id": "nr2-62"
    }
  }, [_vm._v("62")])]), _vm._v(" As we will see later, an expanding print trade and a burgeoning demand for new volumes and titles created, by the mid–eighteenth century, a body of consumers—small estate owners, tradesmen and their families—eager to buy books and to show them off in their homes. In larger houses, or country homes, the library was an important place for public display."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-63",
      "id": "nr2-63"
    }
  }, [_vm._v("63")])]), _vm._v(" Culturally "), _c('i', [_vm._v("arriviste")]), _vm._v(" professionals, keen to learn how to manifest their learning in their homes, read guides on how to arrange and index the books in their library.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In 1759 William Palmer, a London lawyer, acquired a manuscript entitled “Memorandum for making a distinct catalog of a library.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-64",
      "id": "nr2-64"
    }
  }, [_vm._v("64")])]), _vm._v(" The document assumes no prior knowledge of how a library should be arranged, or books marked, so it begins from the basics: the room must be fitted up with shelves placed so as to accommodate folios, quartos, octavos, and below “in such manner as to appear the most agreeable to the eye.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-65",
      "id": "nr2-65"
    }
  }, [_vm._v("65")])]), _vm._v(" Care must be taken not to deface the bindings with the shelf mark, and that when people borrow books, they must name and date their borrowing in the catalogue. This is a manuscript aimed at someone who owned books, but needed fairly basic guidance on how to arrange and record his new possessions.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In aristocratic circles, the library gradually became a communal centre of the house, as it was later to become in the homes of middle-class collectors of books. By the end of the eighteenth century, the library had become the main informal living room in many country houses."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-66",
      "id": "nr2-66"
    }
  }, [_vm._v("66")])]), _vm._v(" When Mrs. Lybbe Powys went to Middleton Park in Oxfordshire in August 1778, she found a library connected to the drawing room where “besides a good collection of "), _c('a', {
    attrs: {
      "id": "p51"
    }
  }), _vm._v("books, there is every other kind of amusement, as billiard and other tables, and a few good pictures.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-67",
      "id": "nr2-67"
    }
  }, [_vm._v("67")])]), _vm._v(" As this suggests, a library contained more than books—prints, coins, busts, and other antiquarian or natural history items, often the focus of conversation, were also in this space—though as William Parkes cautioned in "), _c('i', [_vm._v("Domestic Duties")]), _vm._v(" (1829), it was important not just to assemble these objects but also to find out something about them, or otherwise they would be “mere baubles” and to “display a collection under such circumstances is to emblazon ignorance.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-68",
      "id": "nr2-68"
    }
  }, [_vm._v("68")])]), _vm._v(" The furnishing of the library to accommodate entertainment and group recreation is evident from descriptions and images. By the mid–eighteenth century comfortable library chairs and sofas, along with several writing tables, began to be supplied as standard furnishings."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-69",
      "id": "nr2-69"
    }
  }, [_vm._v("69")])]), _vm._v(" These comfortable items of furniture gave more flexibility to the library as a space, as well as enabling people to read together. Women’s reading became associated with sofas and softness rather than with the intellectually rigorous upright reading of men, and young women were castigated for this unbecoming lounging."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-70",
      "id": "nr2-70"
    }
  }, [_vm._v("70")])]), _vm._v(" Sofas brought their own dangers: it is notable that the library sofas of eighteenth-century novels are more often the places for troubled heroines to lie down and recover, rather than to explore the life of the mind."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-71",
      "id": "nr2-71"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Over the second half of the eighteenth century, sales in book-related furniture and accessories boomed. There was a thriving trade in replica Chippendale library furniture, and in various other items for library decoration: reading chairs, stands, desks, globes, busts, were all available to the middle-class library owner. Hepplewhite’s "), _c('i', [_vm._v("Cabinet Maker and Upholsterer’s Guide,")]), _vm._v(" offering furniture designs for the middling class, provides designs for desk and bookcases, secretary and bookcases, library cases and library tables, and even “cornices for libraries.” Hanging shelves were recommended for “closets or Ladies’ rooms.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-72",
      "id": "nr2-72"
    }
  }, [_vm._v("72")])]), _vm._v(" Those without libraries could combine storage items for books and papers, in pieces such as the “Secretary and Book Case” or the “Desk and Bookcase.” "), _c('i', [_vm._v("New and Elegant Designs [ … ] of Household Furniture in Genteel Taste")]), _vm._v(" (1760), a selection of copperplate designs aimed at a slightly lower sector of the market, boasted a whole section on library and book-related furniture. There were combined writing tables and bookcases, ladies’ bookcases, pediment bookcases, “embattled” bookcases, gothic bookcases, library tables, and “open pediment bureau & bookcase” designs ("), _c('a', {
    attrs: {
      "href": "#/#fig10"
    }
  }, [_vm._v("fig. 10")]), _vm._v(")."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-73",
      "id": "nr2-73"
    }
  }, [_vm._v("73")])]), _vm._v(" As for the contents of these pieces of furniture, they too were touched by a new culture of book display. Homeowners embellished their books with labels that connected the contents of their library to their social "), _c('a', {
    attrs: {
      "id": "p52"
    }
  }), _vm._v("status—bookplates, like book bindings, could be designed around the armorial design of the family.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Williams",
      "src": "images/page_52.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig10"
    }
  }, [_vm._v("Fig. 10. “Lady’s Bookcase,” from "), _c('i', [_vm._v("Household Furniture in Genteel Taste for the Year 1760,")]), _vm._v(" by a Society of Upholsters, Cabinet-makers, &c., printed for Robert Sayer, London, 1760 (© The Geffrye, Museum of the Home, London)")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("We should, however, be cautious in assuming that because people owned furniture with which to store books—bookcases, escritoires, library cases—they necessarily used them for that purpose. Records of domestic thefts from the eighteenth century show that householders often used locked bookcases to store anything that was valuable, which meant that they contained much besides books. The record of one theft from a locked library bookcase in a London house lists the following as the stolen contents: “one bank note, value 100 l. and one other bank note, value 30 l. three gold snuff-boxes, value 100 l. one repeating gold watch, with a brilliant diamond button, value 30 l. one silver candlestick, value 20 s. one silver standish, value 20 s. and 400 l. in money.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-74",
      "id": "nr2-74"
    }
  }, [_vm._v("74")])]), _vm._v(" No books were in the bookcase.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p53"
    }
  }), _vm._v("The library was not the only place in which to read or keep books, and most middling-sort householders would not have had a library. A collection of ninety inventories from the houses of middling-sort Londoners, held at the Geffrye Museum in Shoreditch, gives an insight into the location of books in these more modest households."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-75",
      "id": "nr2-75"
    }
  }, [_vm._v("75")])]), _vm._v(" Looking at the lists of furniture, prints, books, china, linen, and plate, room by room, sometimes reveals where books were kept and, presumably, used. There are few mentions of books or bookcases in upstairs rooms or bedrooms—and only one house has a room called a “library.” Only one home lists books within a servant’s room. By far the majority of these readers’ books are housed in their parlours, suggesting habits of reading within a social space. In a 1740 inventory for the house of John Mitford, a merchant in Bow, we discover that in the “common parlor” (as opposed to his “back parlor” and the drawing room) there is an eight-day clock, nine chairs, a tea board, a dumbwaiter, and “a fine parrot in it ["), _c('i', [_vm._v("sic")]), _vm._v("] Cage & Curtain,” and in addition, a “Stand for a Book.” The fact that this stand is surrounded by the other accoutrements of midcentury visiting suggests that books were read communally. In the 1800 inventory of the late Nicholas Browning, a baker living in Cripplegate, there are two rooms in which “several old books” are listed alongside “a parcel of waste paper” (it’s not clear whether they are part of the waste paper). In his parlour, we find a stuffed parakeet, along with “mahogany secretaire and bookcase with glazed door and pedimenthead,” along with ten assorted chairs and, again, various visiting accessories: “a mahogany knife case, an inlaid tea caddy and silver sugar ditto, a spice box, a pair of sugar knippers a pair of snuffers and stand, a cribbage board, a cork skrew, a small mahogany angle beaufet with glaised doors two china bowles, two basons and a wilton carpet.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-76",
      "id": "nr2-76"
    }
  }, [_vm._v("76")])]), _vm._v(" The parlour was the place of entertainment, with its card tables, gaming boards, musical instruments, and books and reading were part of that domestic culture. It was the prime visiting room in a middle-class eighteenth-century house, and often arranged to facilitate groups sitting together."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-77",
      "id": "nr2-77"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In grander houses, a drawing room, often used for tea and coffee after dinner, was also a reading space, and the midcentury fashion for upholstered seating, particularly long pairs of settees flanking a chimney piece, would have facilitated group entertainment."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-78",
      "id": "nr2-78"
    }
  }, [_vm._v("78")])]), _vm._v(" As the century goes on, we can see an increasing move towards more informal seating arrangements, which seems to suggest that people might have congregated in both larger and smaller groups, the arrangement of the furniture having been flexible enough to accommodate both.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p54"
    }
  }), _vm._v("The furniture of the period tells its own story about changing expectations around sociability. An example is the introduction of casters on both sofas and tables in the mid–eighteenth century, which reveals a demand for furniture that could be moved around to serve different functions. Similarly, tables acquired flaps: no longer a heavy fixed piece in the centre of the room, the table was a more flexible piece of furniture.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Fanny Burney’s discussions with her father over the furnishing of her small new cottage in Westhumble in Surrey illustrate some of the issues to consider when thinking about buying a table for a parlour: “… and if my dearest father will be so good—and so naughty at once, as to crown our "), _c('i', [_vm._v("salle d’Audience")]), _vm._v(" with a gift we shall prize beyond all others, we can think only of a table. Not a dining one, but a sort of table for a little work and a few books, "), _c('i', [_vm._v("en gala")]), _vm._v("—without which, a rooms looks always forlorn.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-79",
      "id": "nr2-79"
    }
  }, [_vm._v("79")])]), _vm._v(" In the event, her father bought two card tables, which were placed on two sides of the room, and Fanny observed of this, “I think no room looks really comfortable, or even quite furnished, without two Tables—one to keep the Wall, & take upon itself the dignity of a little tidyness, the other to stand here—there—& every where, and hold letters & "), _c('i', [_vm._v("make the agreeable.")]), _vm._v("”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-80",
      "id": "nr2-80"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Tables here are used for holding the things one needed “en gala” or “to make the agreeable.” That included books and letters. Burney’s dreams of her parlour as a place of informal entertainment are a shift towards the sociable clustering that we see depicted in the influential landscape designer Humphry Repton’s contrasting images of a dingy cedar parlour, from the earlier part of the century, to the light, bright, and sociable “modern Living Room” of 1816 ("), _c('a', {
    attrs: {
      "href": "#/#fig11"
    }
  }, [_vm._v("fig. 11")]), _vm._v("). Repton’s images are being used to make a point about the new airiness and relaxed sociability of living spaces by the turn of the century. In contrast with the formal circle and the austere and dark formality of the Cedar Parlour, the living room gestures to the outside world through its connection with a conservatory, and is home to four separate sets of people, enjoying its books, seating, and vista in different ways."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-81",
      "id": "nr2-81"
    }
  }, [_vm._v("81")])]), _vm._v(" The tyranny of the fixed circle of social intercourse, typical of the earlier period, was over. Instead, we see a child reading to adults from a huge folio, a silent solitary reader, and women reading from or discussing a book together at a table."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-82",
      "id": "nr2-82"
    }
  }, [_vm._v("82")])]), _vm._v(" Different forms of reading were possible within the same room, with seating arrangements such as these—and the abundance of daylight prevented the need to share artificial light. Repton expects his new room to deliver a lot—nothing less than a transformation of domestic sociability and culture, in "), _c('a', {
    attrs: {
      "id": "p55"
    }
  }), _vm._v("which dullness is banished, to be replaced by a cultural utopia in which no aspect of learning seems inaccessible. This opening up of culture came hand in hand with the architectural opening up of spaces.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Williams",
      "src": "images/page_55.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig11"
    }
  }, [_vm._v("Fig. 11. “Interiors: The Old Cedar Parlour and The Modern Living Room,” from "), _c('i', [_vm._v("Fragments on the Theory and Practice of Landscape Gardening,")]), _vm._v(" by Humphry Repton, published in 1816 (Private Collection / The Stapleton Collection / Bridgeman Images)")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The idea of sitting around a fireplace is a common feature of many evocations of domestic reading and culture in the eighteenth century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-83",
      "id": "nr2-83"
    }
  }, [_vm._v("83")])]), _vm._v(" Beyond its emblematic sociability, the fireside also had the obvious practical benefit of being warm, and often, the greatest source of light in a house. Prolonged reading could be a chilly business. The prolific diarist and traveller Anne Lister struggled with her cold and draughty Yorkshire house, and her endeavours to keep reading despite physical adversity are recorded in some detail in her diaries."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-84",
      "id": "nr2-84"
    }
  }, [_vm._v("84")])]), _vm._v(" For her, reading is a source of entertainment and solace in times of emotional distress. She breaks out in eulogy at one point: “O books! books! "), _c('a', {
    attrs: {
      "id": "p56"
    }
  }), _vm._v("I owe you much. Ye are my spirit’s oil without which, its own friction against itself would wear out.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-85",
      "id": "nr2-85"
    }
  }, [_vm._v("85")])]), _vm._v(" Her reading habit was not, however, a salve to her body in quite the same way. In order to keep her particularly vulnerable parts warm while reading, she goes to the breach makers—in July—and orders a pair of leather knee caps."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-86",
      "id": "nr2-86"
    }
  }, [_vm._v("86")])]), _vm._v(" Here is her account of the ceremony she must go through to be able to sit and read and write:")]), _vm._v(" "), _c('p', {
    staticClass: "ex_alone"
  }, [_vm._v("Plaid wrapped fourfold round my loins, & 2 greatcoats put on over all, besides my leather knee-caps on & a thick dressing gown threwn across my knees over coats & everything. I sit close to the window, all things considered the only seat in the room that suits me. A large high green baize, fold screen on my right to exclude air from the door. The curtains drawn so as only just to admit light enough, to keep out air from the window."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-87",
      "id": "nr2-87"
    }
  }, [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("This is a diary entry written on 19 June!")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("For those who could afford it, the fireside must have been the central focus for gathering and reading in most households, because of the light and the heat that it provided. Hearth tax records from the mid–seventeenth century show that 80 percent of registered houses had one fireplace, 14 percent had two and only 6 percent had three or more."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-88",
      "id": "nr2-88"
    }
  }, [_vm._v("88")])]), _vm._v(" The light generated by the fire would have been more substantial, and perhaps less smoke-filled than the tallow candles and rush lights that were the lighting options for all but the very wealthy. The surviving book catalogue for one country house in Scotland suggests something of the distinctive role of the fireside in book culture. Library records of the time are normally organised by genre and by size of book, rather than location—a catalogue lists contents in divinity, history, law, belles lettres, noting in order of diminishing status, folio, quarto, and octavo and below. But the catalogue for Carmichael House, in South Lanarkshire, organises its content by place. There are historical and religious works in the wainscot presses, legal texts in the chest in the library, books on husbandry in the chests in the dining room. But the works listed in “the press by the fire” are almost all books for entertainment—works of imaginative literature, poems, plays, and romances, many of them dating from the seventeenth century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-89",
      "id": "nr2-89"
    }
  }, [_vm._v("89")])]), _vm._v(" Those books must have been there because they were the books most likely to have been read as part of an evening’s entertainment.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The idea of "), _c('i', [_vm._v("reading")]), _vm._v(" around the fire acquired a symbolic significance in idealised versions of home-entertainment. As Richard Twining, son of a "), _c('a', {
    attrs: {
      "id": "p57"
    }
  }), _vm._v("successful banker and tea and coffee merchant, recollects of his family practices: “Well do I remember the evenings at Isleworth, when after supper we formed a wide circle round the fire, my father often reading some of these olden rhymes to my mother and ourselves. ‘Visions of the past I greet ye still.’”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-90",
      "id": "nr2-90"
    }
  }, [_vm._v("90")])]), _vm._v(" The fireside circle was the subject of many poems in celebration of modest domesticity. Nathaniel Cotton’s popular poem “The Fireside” used the titular image as an emblem of companionable marriage, while William Cowper’s poem "), _c('i', [_vm._v("The Task,")]), _vm._v(" a paean to virtuous rural domesticity, conjures up the pleasure and virtue of this fireside scene in its celebrated description of winter evenings in the countryside. The post was opened, the newspaper was read, and the family settled down for its pastimes:")]), _vm._v(" "), _c('p', {
    staticClass: "poem-t"
  }, [_vm._v("Now stir the fire, and close the shutters fast,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Let fall the curtains, wheel the sofa round,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And, while the bubbling and loud-hissing urn")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Throws up a steamy column, and the cups")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That cheer but not inebriate, wait on each,")]), _vm._v(" "), _c('p', {
    staticClass: "poem-b"
  }, [_vm._v("So let us welcome peaceful ev’ning in."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-91",
      "id": "nr2-91"
    }
  }, [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The ongoing allure of reading by the cosy fireside is evident in the titles of the popular literary compilations of the mid–late eighteenth century, packaged to suggest domestic harmony and sociability: "), _c('i', [_vm._v("The Banquet of Wit: containing a choice collection of Bon-Mots, Jests, Repartees, for the Amusement of the Fire-side")]), _vm._v(" (1790); "), _c('i', [_vm._v("A Companion for the Fire-side; or, Winter Evening’s Amusement. Containing a curious collection of entertaining and instructive essays, visions, Relations, Stories, Tales, Fables")]), _vm._v(" (1769).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("On the upper floors of homes were bedrooms, closets, and dressing rooms, which also offered venues for more intimate communal reading. The adolescent Eliza Tyrrell describes her friend reading one of Amelia Opie’s "), _c('i', [_vm._v("Simple Tales")]), _vm._v(" to her in bed, and while she is dressing in the morning, and this informal scene reflects what must have been widespread practice."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-92",
      "id": "nr2-92"
    }
  }, [_vm._v("92")])]), _vm._v(" The most undocumented and probably the most frequent forms of communal reading were in very small groups, between two or three people, in couples, families, and friends. The learned and cultured “ladies of Llangollen,” Eleanor Butler and Sarah Ponsonby, who lived for forty years in domestic bliss in north Wales, write about reading together as part of their intimacy. In her diary entries, Butler presents the relationship between reader and busy listener as a shared cultural space. She writes on 24 September 1781: “Read Madame de "), _c('a', {
    attrs: {
      "id": "p58"
    }
  }), _vm._v("Sévigné. My Love drawing. From seven till nine in sweet converse with the delight of my heart, over the Fire. Paper’d our Hair.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-93",
      "id": "nr2-93"
    }
  }, [_vm._v("93")])]), _vm._v(" On October 7, she is “Reading Rousseau to my Sally. She drawing her map upon Vellum, made a great mistake in one of the tropics which spoil’d her morning’s Work … Incessant rain the entire evening. Shut the shutters, made a good fire, lighted the Candles … A day of strict retirement, sentiment, and delight.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-94",
      "id": "nr2-94"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("For the self-educated bookseller James Lackington, marriage represents the chance to share a world of reading together for the first time: “I was in raptures with the bare thoughts of having a woman to read with, and also to read to me.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-95",
      "id": "nr2-95"
    }
  }, [_vm._v("95")])]), _vm._v(" Lackington’s sentiments on mutual reading are echoed by the writer and engineer Richard Lovell Edgeworth; although several rungs up on the social ladder, he shows the same enthusiasm for a joint reading experience: “I strenuously endeavoured to improve my own understanding, and to communicate whatever I knew to my wife. Indeed while we read and conversed together, during the long winter evenings, the clearness of her judgement assisted me in every pursuit of literature, in which I was engaged.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-96",
      "id": "nr2-96"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Books both passed the time and provided the basis for conversation and discussion."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-97",
      "id": "nr2-97"
    }
  }, [_vm._v("97")])]), _vm._v(" Bookish converse was not the exclusive preserve of married couples, however. Mary Delany talks of the pleasure of spending evenings reading with a female friend, which gives them both the chance to consider the book fully: “we quite chew it and dwell upon its taste.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-98",
      "id": "nr2-98"
    }
  }, [_vm._v("98")])]), _vm._v(" Reading, whatever the subject matter, brought Delany closer to her friends, as is evidenced by the wet day in November 1774 when it “never ceased raining,” and she decided to stay indoors and read with her friends: “We are now consoling ourselves, with books [ … ] they entertain us and tell us pretty moral tales; they banish scandal and politicks, but not "), _c('i', [_vm._v("one moment’s remembrance")]), _vm._v(" of the friends we admire, respect, and love.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-99",
      "id": "nr2-99"
    }
  }, [_vm._v("99")])]), _vm._v(" The point of reading, for Delany, was not personal literary development, but the sharing of experience, as she remarked when explaining her friendship with the Duchess of Portland: “we read and like the "), _c('i', [_vm._v("same")]), _vm._v(" books, we talk them over without interruption, we are fond of the "), _c('i', [_vm._v("same")]), _vm._v(" works; and the pleasures of these occupations are increased by participation.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-100",
      "id": "nr2-100"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Reading and Leisure")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Anxiety over how to employ leisure hours permeates the conduct literature of the eighteenth century, an inevitable consequence of the rising affluence that kept increasing numbers of middling-sort women idle in the house "), _c('a', {
    attrs: {
      "id": "p59"
    }
  }), _vm._v("rather than out in the workplace."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-101",
      "id": "nr2-101"
    }
  }, [_vm._v("101")])]), _vm._v(" An article from the "), _c('i', [_vm._v("Gentleman’s Magazine")]), _vm._v(" from 1801 lamented the social changes in the role of women in the home: “Now [ … ] these farmers’ daughters [ … ] instead of dishing butter, feeding poultry, or curing bacon, the avocations of these young "), _c('i', [_vm._v("ladies")]), _vm._v(" at home are, studying dress, attitudes, novels, French, and music, whilst the fine ladies their mothers sit lounging in parlors adorned with the fiddle-faddle fancy-work of their fashionable daughters.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-102",
      "id": "nr2-102"
    }
  }, [_vm._v("102")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Unbroken leisure became a symbol of a family’s status."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-103",
      "id": "nr2-103"
    }
  }, [_vm._v("103")])]), _vm._v(" One of the ironies of eighteenth-century social history was that having time to spare was both the desired reward for hard work and a source of concern. Thomas Gisborne, author of "), _c('i', [_vm._v("An Enquiry into the Duties of the Female Sex")]), _vm._v(" (1798), announced piously in his chapter “On the Employment of Time”: “Time is a sacred trust consigned to us by the Creator of the universe.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-104",
      "id": "nr2-104"
    }
  }, [_vm._v("104")])]), _vm._v(" All those sacred hours needed to be used, and used well. Educational reading and study played an important role in this—Gisborne says that “the habit of regularly allotting to improving books a portion of each day [ … ] cannot be too strongly recommended.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-105",
      "id": "nr2-105"
    }
  }, [_vm._v("105")])]), _vm._v(" Within the home, women were often represented as men’s leisure companions: one male physician writes in 1740 that ladies were “made to serve us as Play-toys after our more serious Occupations.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-106",
      "id": "nr2-106"
    }
  }, [_vm._v("106")])]), _vm._v(" In her treatise "), _c('i', [_vm._v("Letter to a New-Married Lady")]), _vm._v(" (1777), Hester Chapone warned her readers of the potential ennui of marriage, and suggested what could be done to avoid it. She cautions them to beware “of all things” “his growing dull and weary in your company.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-107",
      "id": "nr2-107"
    }
  }, [_vm._v("107")])]), _vm._v(" One way of avoiding this fate is to read with him: “And though you should not naturally be disposed to the same taste in reading or amusement, this may be acquired by habit, and by a hearty desire of conforming to his inclinations and sharing in his pleasures.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-108",
      "id": "nr2-108"
    }
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Chapone’s idea that a wife should bend to her husband’s tastes and interests was not shared by everyone. Other women used the practice of reading with their spouse to different ends. Jane Collier’s satirical conduct book "), _c('i', [_vm._v("An Essay on the Art of Ingeniously Tormenting")]), _vm._v(" (1753) contains a section on how to rile a husband by refusing to listen to him while he reads: “If, for example, he desires you to hear one of Shakespeare’s plays, you may give him perpetual interruptions, by sometimes going out of the room, sometimes ringing the bell to give orders for what cannot be wanted till the next day; at other times taking notice (if your children are in the room), that Molly’s cap is awry, or that Jackey looks pale.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-109",
      "id": "nr2-109"
    }
  }, [_vm._v("109")])]), _vm._v(" As Collier reminds us, not every marriage was a happy one, and not every home was a bower of bliss. Books "), _c('a', {
    attrs: {
      "id": "p60"
    }
  }), _vm._v("and newspapers could screen couples from one another, and create barriers to communication."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-110",
      "id": "nr2-110"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Gillray’s paired engravings of "), _c('i', [_vm._v("Harmony Before Matrimony")]), _vm._v(" and "), _c('i', [_vm._v("Matrimonial-Harmonics")]), _vm._v(" literalise the ideas of domestic concord, depicting the soundscape of before and after marriage (figs. 12 and 13). In the first plate the couple sing love duets together and read Ovid, their voices, minds, and bodies in happy union. Pets play peaceably, and the room is an elegant haven of culture. In the second, set in the breakfast room, the emotional chaos of dissension is audible and visible. The wife sings alone: the pages of her open music book are headed “Forte,” and her song is “Torture Fiery Rage / Despair I cannot can not bear.” On the piano lies music: “Separation: a Finale for Two Voices with Accompaniment,” while on the floor is “The Wedding Ring—a Dirge.” The husband, carelessly dressed, consults the "), _c('i', [_vm._v("Sporting Calendar")]), _vm._v(" and looks dejected. The decibel level is augmented by a screeching baby, its nursemaid frantically waving his rattle, accompanied by a hissing urn of coffee, a barking dog, and two screeching cockatoos. The "), _c('i', [_vm._v("Art of Tormenting")]), _vm._v(" sits open on a chair. It’s worth bearing in mind that the happy evocation of homely converse celebrated in so many advice manuals sat alongside a vigorous visual and verbal tradition depicting miserable homes and marriages, often divided in their cultural consumption."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-111",
      "id": "nr2-111"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("So far this chapter has been concerned with the world of sociable reading inside the walls of the home. To assume that this was the only place in which individuals read together would be a mistake. They also read in taverns, and coffeehouses, circulating libraries, and other gathering places. And even within the domestic arena, there was more to the home than the house. For the more affluent middle class and gentry, at one remove from the house itself was the summer house, a nearby structure that allowed for the possibility of cool but covered outdoor space. Its primary function was as a “pleasure-house,” a different location within which to spend leisure time. The design and scale of summer houses varied considerably—simple and rustic, classical, or personalised, reflecting the whims and eccentricities of their owners. Some were open, but some evidently were sufficiently protected from the elements as to enable their owners to store books within them: the records of at least two cases of book theft in the first half of the eighteenth century show that these locations were vulnerable to burglaries. Thomas Thompson, the owner of what he describes as “a little house in Weybridge,” reported a burglary on 14 December of the previous year, when “they cut through the Wall of my Summer-house, and threw out one hundred Books more than they took away; I found them upon the Ground in my Neighbour’s Orchard; they took away seventy Octavo’s, Quarto’s and Folio’s; twelve Volumes of Rapin’s History, in Octavo, &c.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-112",
      "id": "nr2-112"
    }
  }, [_vm._v("112")])]), _vm._v(" Thompson obviously had a fairly substantial collection within his summer house. The tendency to locate a “pleasure-house” at a remove from the main house meant that they could be used for solitary "), _c('i', [_vm._v("or")]), _vm._v(" social activities. Reading within them could take both forms."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-113",
      "id": "nr2-113"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p61"
    }
  }), _c('img', {
    attrs: {
      "alt": "Williams",
      "src": "images/page_61.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig12"
    }
  }, [_vm._v("Fig. 12. James Gillray, "), _c('i', [_vm._v("Harmony Before Matrimony,")]), _vm._v(" London, October 1792, engraving (Library of Congress, LC-USZ62-100133)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Williams",
      "src": "images/page_61a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig13"
    }
  }, [_vm._v("Fig. 13. James Gillray, "), _c('i', [_vm._v("Matrimonial-Harmonics,")]), _vm._v(" London, 25 October 1805, engraving (Library of Congress, LC-USZ62-100134)")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p62"
    }
  }), _vm._v("A lot of reading also happened "), _c('i', [_vm._v("en plein air.")]), _vm._v(" Idealised neoclassical images of families reading together in groves and grassy banks that adorn the frontispieces of eighteenth-century books may romanticise the outdoor scene, but they represent a common practice. Heavy taxation on both glass and candles during the eighteenth century must have made many middling-sort homes fairly dingy places, so it is not surprising that readers took their culture outdoors. Mary Rathbone, a Shropshire Quaker woman, records that she “sat in the garden and sewed, while my Bro. Richard read ‘Sandford and Merton.’” On other occasions a relative reads the "), _c('i', [_vm._v("Spectator")]), _vm._v(" to her in the garden, and on another, Cook’s voyages."), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-114",
      "id": "nr2-114"
    }
  }, [_vm._v("114")])]), _vm._v(" Mary Delany frequently reads outside, in a grove or grotto, and even on the beach—in “a little sand grotto.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-115",
      "id": "nr2-115"
    }
  }, [_vm._v("115")])]), _vm._v(" As we have seen, Gertrude Savile walks with her maid and reads in the fields. She also goes for a trip to Clapham Common with her mother, and while there reads her “Agnes de Castro,” a short piece of prose fiction by Aphra Behn. The next day they go a few miles up Kingston Road, where she begins another novella by Behn, "), _c('i', [_vm._v("The Fair Jilt.")]), _vm._v(" They finish this the following day, during their afternoon in Wimbledon; and later on, after supper, they read part of Behn’s "), _c('i', [_vm._v("Oroonoko.")]), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-116",
      "id": "nr2-116"
    }
  }, [_vm._v("116")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Savile’s reading trips are a reminder of the importance of being able to carry around eighteenth-century leisure reading—a factor frequently mentioned in advertisements for books and in prefatory material. "), _c('i', [_vm._v("The Aviary, or, Magazine of British Melody")]), _vm._v(" described its collection of 1,443 songs as “all within the Compass of a portable Pocket Volume.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-117",
      "id": "nr2-117"
    }
  }, [_vm._v("117")])]), _vm._v(" The compiler of "), _c('i', [_vm._v("The Companion: being a Choice Collection of the Most Admired Pieces from the Best Authors")]), _vm._v(" (1790) claimed to contain “such literary provision as may save the trouble and expence of the carriage of many volumes” and was ideal for carrying around, being “of a proper portable size.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-118",
      "id": "nr2-118"
    }
  }, [_vm._v("118")])]), _vm._v(" Just as modern travellers would take a novel, an iPod, or an iPad as a time-killer, so in the eighteenth century on journeys one read while travelling—or waiting to travel. Horse-drawn transport, not to mention potholed roads, would have drawn out the "), _c('a', {
    attrs: {
      "id": "p63"
    }
  }), _vm._v("length of even the shortest trip. When John Chubb made his long journey as a teenager from Somerset to London, he was travel-sick most of the way to Bath, but then recovered enough to get profoundly bored on the rest of the journey, later writing to his father: “I never wanted a book so much in my life as in the Coach to day.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-119",
      "id": "nr2-119"
    }
  }, [_vm._v("119")])]), _vm._v(" Mary Delany notes in a letter following a journey: “Sally breakfasted at Causcomb in her way to Stow, and brought a book for our amusement in the coach, entitled “Letters from Lady Catesby to Lady Henrietta [translated by Mrs. Brooke]”; they are odd, interesting, and pretty for a love story—a translation from the French; some pretty sentiments and uncommon characters. It is on the whole amusing, and answered the end for which it was lent us.”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-120",
      "id": "nr2-120"
    }
  }, [_vm._v("120")])]), _vm._v(" Like many travelling to Ireland, Delany was at times delayed by bad weather, and records that “‘The Rambler’ and ‘Adventurer’ entertain us by turns—we give the preference to the ‘Adventurer.’”"), _c('sup', {
    staticClass: "endnote"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#en2-121",
      "id": "nr2-121"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "orna"
  }, [_c('img', {
    attrs: {
      "alt": "Williams",
      "src": "images/ornament.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("The physical and social contexts in which people read assumed many kinds, and as we shall see, this variety came to shape the form of the book itself. Once we relocate the book in the parlour, garden, or carriage, we can start to see how the history of reading in its social context is inseparable from other areas of eighteenth-century life: concerns about public sociability, idleness, loneliness, the virtues of conversation, the cementing of intimate relationships. People looked at each others’ houses and watched each other read. As they did so, they made judgements: not just about how well someone else read, but the kinds of books that person was reading. Books read at home could have a very personal significance for their readers and listeners, but they were also part of the way in which one displayed a self for the world.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ba6371a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/2_reading_and_sociability.vue
// module id = 81
// module chunks = 0